import { SuitesType } from '@api';
import { z } from 'zod';

const suitesFormSchema = z.object({
  seats: z.number().nullable(),
  uplift: z.number().nullable(),
  share: z.number().nullable(),
  notes: z.string(),
});

type SuitesFormSchemaType = typeof suitesFormSchema;
export type SuitesFormDataType = z.infer<SuitesFormSchemaType>;

type UseVenueSuitesFormSchemaReturnType = {
  schema: SuitesFormSchemaType;
  defaultValues: SuitesFormDataType;
};

export const useVenueSuitesFormSchema = (
  venueSuites: SuitesType
): UseVenueSuitesFormSchemaReturnType => {
  const defaultValues: SuitesFormDataType = {
    seats: venueSuites.seats,
    uplift: venueSuites.uplift ? venueSuites.uplift.value : null,
    share: venueSuites.share ? venueSuites.share.value : null,
    notes: venueSuites.notes ?? '',
  };

  return { schema: suitesFormSchema, defaultValues };
};
